import { render, staticRenderFns } from "./DisableP2PSaveVoiceTenantEdit.vue?vue&type=template&id=0776553d&scoped=true"
import script from "./DisableP2PSaveVoiceTenantEdit.vue?vue&type=script&lang=js"
export * from "./DisableP2PSaveVoiceTenantEdit.vue?vue&type=script&lang=js"
import style0 from "./DisableP2PSaveVoiceTenantEdit.vue?vue&type=style&index=0&id=0776553d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0776553d",
  null
  
)

export default component.exports